import React from 'react';

interface BannerProps {
  href: string;
  imgSrc: string;
  width: number;
  height: number;
  className?: string;
  alt?: string;
}

const A8Banner: React.FC<BannerProps> = ({ href, imgSrc, width, height, className, alt = '' }) => {
  return (
    <div className={className}>
      <a href={href} rel="nofollow noreferrer" target="_blank">
        <img style={{ border: 0 }} width={width} height={height} alt={alt} src={imgSrc} />
      </a>
      {/* トラッキングピクセル（素材ごとに異なるため、必要に応じて個別コンポーネント側で指定） */}
    </div>
  );
};

interface PixelProps {
  src: string;
}

const TrackingPixel: React.FC<PixelProps> = ({ src }) => (
  <img style={{ border: 0 }} width={1} height={1} src={src} alt="" />
);

interface TextAdProps {
  href: string;
  text: string;
  className?: string;
}

const A8TextAd: React.FC<TextAdProps> = ({ href, text, className }) => (
  <div className={className}>
    <a href={href} rel="nofollow noreferrer" target="_blank">{text}</a>
  </div>
);

// ===== 素材別のラッパー =====

// 素材ID 004: バナー 100x60 高解像度
export const A8Banner100x60: React.FC<{ className?: string }> = ({ className }) => (
  <div className={className}>
    <A8Banner
      href="https://px.a8.net/svt/ejp?a8mat=45DZ24+5CB16A+1WP2+1BNJ9D"
      imgSrc="https://www20.a8.net/svt/bgt?aid=250914748323&wid=001&eno=01&mid=s00000008903008004000&mc=1"
      width={100}
      height={60}
    />
    <TrackingPixel src="https://www18.a8.net/0.gif?a8mat=45DZ24+5CB16A+1WP2+1BNJ9D" />
  </div>
);

// 素材ID 005: バナー 234x60
export const A8Banner234x60: React.FC<{ className?: string }> = ({ className }) => (
  <div className={className}>
    <A8Banner
      href="https://px.a8.net/svt/ejp?a8mat=45DZ24+5CB16A+1WP2+1BNQZ5"
      imgSrc="https://www20.a8.net/svt/bgt?aid=250914748323&wid=001&eno=01&mid=s00000008903008005000&mc=1"
      width={234}
      height={60}
    />
    <TrackingPixel src="https://www13.a8.net/0.gif?a8mat=45DZ24+5CB16A+1WP2+1BNQZ5" />
  </div>
);

// 素材ID 006: バナー 320x50
export const A8Banner320x50: React.FC<{ className?: string }> = ({ className }) => (
  <div className={className}>
    <A8Banner
      href="https://px.a8.net/svt/ejp?a8mat=45DZ24+5CB16A+1WP2+1BNYOX"
      imgSrc="https://www20.a8.net/svt/bgt?aid=250914748323&wid=001&eno=01&mid=s00000008903008006000&mc=1"
      width={320}
      height={50}
    />
    <TrackingPixel src="https://www12.a8.net/0.gif?a8mat=45DZ24+5CB16A+1WP2+1BNYOX" />
  </div>
);

// 素材ID 002: テキスト
export const A8Text002: React.FC<{ className?: string }>= ({ className }) => (
  <div className={className}>
    <A8TextAd
      href="https://px.a8.net/svt/ejp?a8mat=45DZ24+5CB16A+1WP2+1BN3TU"
      text="【PR】DMM.com証券の新規アカウント登録のお申込みはこちら"
    />
    <TrackingPixel src="https://www15.a8.net/0.gif?a8mat=45DZ24+5CB16A+1WP2+1BN3TU" />
  </div>
);

export default A8Banner;


